import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { RingLoader } from "react-spinners";
import {
  filterToggle,
  isFilterOpen,
  toggleCart,
  toggleModal,
  toggleCustomerDetail
} from "../../../store/common";
import {
  setDualCartData
} from "../../../store/cart";

import shop from "../../../api/shop";
import { store } from "../../../main.js";
import {
  getCustomers,
  storeCustomers,
  getOpenedActionBarId,
  setOpenedActions,
  customerAction,
  clearCustomerData,
  loadingCustomers,
  loadingCustomerCart,
  storeCustomerCartToPreview
} from "../../../store/customer";
import Customer from "../components/Customer";
import CustomerList from "../components/CustomerList";
import { userIsAuthenticated } from "../../../auth";
import { getTranslate } from "react-localize-redux";
import DualCartModal from "../../../containers/DualCartModal.js";

class CustomersContainer extends Component {
  componentDidMount() {
    store.dispatch(toggleCart(false));
    if (store.getState().customer.list.length === 0) {
      store.dispatch(clearCustomerData());
      store.dispatch(loadingCustomers(true));
      shop.getCustomers(store.getState().common.oz.id, customersPromise => {
        customersPromise.then(customers => {
          store.dispatch(storeCustomers(customers));
          store.dispatch(loadingCustomers(false));
        });
      });
    }
  }

  render() {
    return (
      <div className="customerList">
        <CustomerList
          loading={false}
          isFilterOpen={this.props.isFilterOpen}
          filterToggle={() => this.props.filterToggle()}
          title={this.props.translate(
            "molecules.containers.customersFilter.title"
          )}
          refresh={() => this.props.refreshCustomers(this.props.currentOZ)}
        >
          <div className="row">
            <div className="col-12 col-md-3 customer-name">
              {this.props.translate("routes.customerList.header.name")}
            </div>
            <div className="col-12 col-md-8">
              <div className="row">
                <div className="col-12 col-md-2 customer-name">FLEXCode</div>
                <div className="col-12 col-md-2 customer-action">
                  {this.props.translate("routes.customerList.header.phone")}
                </div>
                <div className="col-12 col-md-2 customer-action">
                  {this.props.translate("routes.customerList.header.email")}
                </div>
                <div className="col-12 col-md-3 customer-action">
                  {this.props.translate("routes.customerList.header.address")}
                </div>
                <div className="col-12 col-md-3 customer-action">
                  {this.props.translate("routes.customerList.header.shipping")}
                </div>
              </div>
            </div>
          </div>
          {this.props.customers.length > 0
            ? this.props.customers.map(customer => (
              <Customer
                key={customer.personal.id}
                name={customer.company.company}
                address={
                  customer.company.street +
                  ", " +
                  customer.company.zip +
                  ", " +
                  customer.company.city
                }
                shippingAddress={
                  customer.shippingAddress.street +
                  ", " +
                  customer.shippingAddress.zip +
                  ", " +
                  customer.shippingAddress.city
                }
                phone={customer.personal.phone}
                email={customer.personal.email
                }
                code={customer.personal.code}
                id={customer.personal.id}
                openedId={this.props.openedId}
                setOpened={this.props.setOpened}
                openDualCart={() => {
                  this.props.openDualCart(customer.personal.id)
                }}
                customerAction={this.props.customerAction}
                openOrders={customer.orderType}
                getCustomerCart={() =>
                  this.props.getCustomerCart(customer.personal.id)
                }
                isCartLoading={this.props.isLoadingCustomerCart}
                labelBasic={this.props.translate(
                  "routes.customerList.customerActionRow.action_basic"
                )}
                labelSpecial={this.props.translate(
                  "routes.customerList.customerActionRow.action_special"
                )}
                labelClaim={this.props.translate(
                  "routes.customerList.customerActionRow.action_claim"
                )}
                labelWarehouse={this.props.translate(
                  "routes.customerList.customerActionRow.action_warehouse"
                )}
                labelCommission={this.props.translate(
                  "routes.customerList.customerActionRow.action_commision"
                )}
                isSpecialCart={customer.specialCart > 0}
              />
            ))
            : !this.props.isLoading && (
              <div className="text-center">
                {this.props.translate(
                  "molecules.containers.cartInHeaders.no_items"
                )}
              </div>
            )}
          {this.props.isLoading && (
            <div className="spinner">
              <RingLoader color={"#d42e2b"} loading size={120} margin={20} />
            </div>
          )}
        </CustomerList>
        <DualCartModal />
      </div>
    );
  }
}

CustomersContainer.propTypes = {
  isFilterOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  filterToggle: PropTypes.func,
  customers: PropTypes.array,
  openedId: PropTypes.string,
  setOpened: PropTypes.func,
  customerAction: PropTypes.func,
  translate: PropTypes.func,
  getCustomerCart: PropTypes.func,
  refreshCustomers: PropTypes.func,
  openDualCart: PropTypes.func,
  isLoadingCustomerCart: PropTypes.bool
};

const mapStateToProps = ({ customer, common, locale }) => ({
  translate: getTranslate(locale),
  customers: getCustomers(customer.searchList),
  isLoading: customer.loading,
  isFilterOpen: isFilterOpen(common.filterOpen),
  openedId: getOpenedActionBarId(customer.actionBarActive),
  currentOZ: common.oz.id,
  isLoadingCustomerCart: customer.loadingCart
});

const mapDispatchToProps = dispatch => ({
  setOpened: (id, e) => {
    if (
      e.target.parentElement.className === "action" ||
      e.target.className === "action"
    ) {
    } else {
      dispatch(setOpenedActions(id));
    }
  },
  filterToggle: () => dispatch(filterToggle()),
  customerAction: type => {
    dispatch(toggleCustomerDetail(false));
    dispatch(customerAction(type));
    browserHistory.push(`/products`);
  },
  refreshCustomers: ozId => {
    dispatch(clearCustomerData());
    dispatch(loadingCustomers(true));
    shop.getCustomers(ozId, customersPromise => {
      customersPromise.then(customers => {
        dispatch(storeCustomers(customers));
        dispatch(loadingCustomers(false));
      });
    });
  },
  getCustomerCart: customerId => {
    dispatch(loadingCustomerCart(true));
    shop.getCustomerCartItems(customerId, cartPromise => {
      cartPromise.then(cartItems => {
        console.log(cartItems);
        dispatch(storeCustomerCartToPreview(cartItems));
        dispatch(toggleModal("customer_cart", true));
        dispatch(loadingCustomerCart(false));
      });
    });
  },
  openDualCart: customerId => {
    dispatch(setDualCartData({ customerId }))
    dispatch(toggleModal("customer_dual_cart", true));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userIsAuthenticated(CustomersContainer));



// WEBPACK FOOTER //
// ./src/routes/CustomerList/containers/CustomersContainer.js